export const SOURCE_FOLDERS_PAGE_SIZE = 100;
